module.exports = __webpack_public_path__ + "static/media/4-audio.8e18818.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-audio.wav
// module id = rwC/
// module chunks = 0